const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  fullname: state => state.user.fullname,
  institutionId: state => state.user.institutionId,
  logo: state => state.user.logo,
  permissions: state => state.user.permissions,
  isAdmin: state => state.user.isAdmin,
  menu: state => state.user.menu
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js